/**
 * The number beside **My learning** in the rail.
 *
 * The design puts a count on that row, and there is no cheap route that answers
 * only "how many". `GET /home` and `GET /learning` both already carry
 * `counts.assigned` — the same arithmetic, by contract — so the two pages
 * publish it here as they load and the rail reads it. Nothing fetches for this.
 *
 * The consequence, and it is the right one: before either page has loaded, the
 * row carries no number rather than a zero. A zero would be a fact, and it
 * would be wrong.
 */

import { useSyncExternalStore } from 'react';

let assigned: number | null = null;
const listeners = new Set<() => void>();

export function setAssignedCount(next: number): void {
  if (assigned === next) return;
  assigned = next;
  for (const listener of listeners) listener();
}

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const snapshot = (): number | null => assigned;

export const useAssignedCount = (): number | null =>
  useSyncExternalStore(subscribe, snapshot, snapshot);
